import { defineStore } from "pinia";
import { CustomerOrderListResults } from "~/composables";

export const useOrderStore = defineStore("order", {
  state: () => ({
    listOrder: null as CustomerOrderListResults | null,
  }),
});
